import { createAction } from 'redux-actions'

export const setAppointmentConfirmationContactDetails = createAction('QUOTE_PAGE/SET_APPOINTMENT_CONFIRMATION_CONTACT_DETAILS')
export const clearAppointmentConfirmationContactDetails = createAction('QUOTE_PAGE/CLEAR_APPOINTMENT_CONFIRMATION_CONTACT_DETAILS')
